import React from 'react';
import { Link } from 'react-router-dom';

const tuiles = [
  { to: '/paie/rapports/livre-paie', titre: 'Livre de paie', desc: 'Récapitulatif mensuel complet' },
  { to: '/paie/rapports/export-comptable', titre: 'Export comptable', desc: 'Écritures SYSCOHADA' },
  { to: '/paie/rapports/audit', titre: 'Rapport d\'audit', desc: 'Historique des opérations' },
  { to: '/paie/bulletins/tableau', titre: 'État de rémunération', desc: 'Export mensuel par employé (XLSX)' },
];

export function RapportsDashboardPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-content mb-6">Rapports</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {tuiles.map(t => (
          <Link key={t.to} to={t.to} className="bg-surface border border-border rounded-lg p-5 hover:border-accent hover:shadow-sm transition">
            <h2 className="font-semibold text-content mb-1">{t.titre}</h2>
            <p className="text-sm text-content-subtle">{t.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
